export const OrganizationItemMockData = {
  id: 'fc7c3553-d3ea-4538-9192-08db83c643a8',
  displayName: 'Mock Organization Item Display Name',
  email: 'mockorg@gmail.com',
  address: 'Mock Organization Item Address',
  createdOn: '2023-07-13T19:28:16.5707362+00:00',
  createdById: '3c59cbfb-c68b-eb11-b566-000d3a2238b1',
  members: [
    {
      userId: '09981c8a-b591-ed11-9d7a-000d3a2a1830',
      displayName: 'Mock Organization User',
      email: 'mockorguser@gmail.com',
      resendInvitation: true,
      roles: [
        {
          role: 'ORGANIZATION MASTER',
          roleId: 'f31dff69-b321-ee11-b630-2c6dc19c19d5',
        },
      ],
    },
  ],
  isPartner: false,
  isBlocked: false,
  defaultLanguage: 'en',
  creationStatus: 'Available',
  creationStatusDescription: 'Organization creation process is finished',
} as any;
